import { Navigate } from "react-router-dom";
import { checkUserType } from "../../utils/helper";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { showToast } from "../../redux/guest-slices/other.slice";

const MemberOrGuestRoute = ({ children }) => {
  const dispatch = useDispatch();
  const userType = checkUserType();

  useEffect(() => {
    if (userType === "specialist") {
      dispatch(
        showToast({
          type: "info",
          message: "This page is only available for Members.",
        })
      );
    }
  }, [userType, dispatch]);

  if (userType === "specialist") {
    return <Navigate to="/specialist/profile" replace />;
  }

  return children;
};

export default MemberOrGuestRoute;